var _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const Svg111 = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "black"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 2.78564,
  y: 2.78516,
  width: 18.4286,
  height: 4.71429,
  fill: "white",
  stroke: "white"
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  x: 2.78564,
  y: 9.64453,
  width: 18.4286,
  height: 4.71429,
  fill: "white",
  stroke: "white"
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  x: 2.78564,
  y: 16.5,
  width: 18.4286,
  height: 4.71429,
  fill: "white",
  stroke: "white"
})));
const ForwardRef = /*#__PURE__*/forwardRef(Svg111);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "a5c8099c74523cd61c5b2ae455de47af.svg";